var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.25c3.105 0 5.625-2.52 5.625-5.625S13.105 0 10 0 4.375 2.52 4.375 5.625 6.895 11.25 10 11.25zm5 1.25h-2.152c-.868.398-1.832.625-2.848.625-1.016 0-1.977-.227-2.848-.625H5c-2.762 0-5 2.238-5 5v.625C0 19.16.84 20 1.875 20h16.25C19.16 20 20 19.16 20 18.125V17.5c0-2.762-2.238-5-5-5z",
    transform: "translate(2 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockEmployees);
export default __webpack_public_path__ + "static/media/block-employees.e102e84f55963633affdebb1c0f6a35d.svg";
export { ForwardRef as ReactComponent };